export const SIGN_UP_BUTTON_WIDTH_DESKTOP = 228;
